
import React from 'react';
import { Link } from 'react-router-dom';
import './Table.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit, faUser, faEye, faArrowLeft
} from '@fortawesome/free-solid-svg-icons';


const Table = () => {
    return (
        <div className="container mt-6">
            <div className="row">
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Simple Table</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-custom">
                                    <tr>
                                        <th>S.N</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Actions</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>Rohan Patil</td>
                                        <td>PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Ravi Shankar</td>
                                        <td>Senior PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Mukesh Kumar</td>
                                        <td>Magento Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Bordered Table</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-custom table-bordered">
                                    <tr>
                                        <th>S.N</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Actions</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>Rohan Patil</td>
                                        <td>PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Ravi Shankar</td>
                                        <td>Senior PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Mukesh Kumar</td>
                                        <td>Magento Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Bordered Table</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-custom table-bordered-full">
                                    <tr>
                                        <th>S.N</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Actions</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>Rohan Patil</td>
                                        <td>PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Ravi Shankar</td>
                                        <td>Senior PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Mukesh Kumar</td>
                                        <td>Magento Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                </table>
                                <nav aria-label="...">
                                    <ul className="pagination">
                                        <li classname="page-item disabled">
                                            <a className="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                                        </li>
                                        <li className="page-item"><a className="page-link" href="#">1</a></li>
                                        <li className="page-item active" aria-current="page">
                                            <a className="page-link" href="#">2</a>
                                        </li>
                                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                                        <li className="page-item">
                                            <a className="page-link" href="#">Next</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Hover Effect Table</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-custom table-bordered-full table-hover">
                                    <tr>
                                        <th>S.N</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Actions</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>Rohan Patil</td>
                                        <td>PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Ravi Shankar</td>
                                        <td>Senior PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Mukesh Kumar</td>
                                        <td>Magento Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        <li className="page-item">
                                            <a className="page-link" href="#" aria-label="Previous">
                                                <span aria-hidden="true">&laquo;</span>
                                            </a>
                                        </li>
                                        <li className="page-item"><a className="page-link" href="#">1</a></li>
                                        <li className="page-item"><a className="page-link" href="#">2</a></li>
                                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                                        <li className="page-item">
                                        <a className="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                        </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-lg-4">
                                    <h3 className="h5">Full Width Table</h3>
                                </div>
                                <div className="col-lg-8">
                                    <div className="float-end ml-20 mr-10 mt-1">
                                        <Link to="/">
                                            <FontAwesomeIcon icon={faArrowLeft} className="mr-10" />
                                        </Link>
                                    </div>
                                    <div class="form-radio float-end">
                                        <div class="radio-inline mr-20">
                                            <input id="demo-1" type="radio" value="demo_1" name="radio" />
                                            <label class="form-label" for="demo-1">Active</label>
                                        </div>
                                        <div class="radio-inline mr-20">
                                            <input id="demo-2" type="radio" value="demo_2" name="radio" />
                                            <label class="form-label" for="demo-2">In Active</label>
                                        </div>
                                        <div class="radio-inline mr-20">
                                            <input id="demo-3" type="radio" value="demo_3" name="radio" />
                                            <label class="form-label" for="demo-3">All</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <div className="row align-items-end">
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">Records</label>
                                            <select className="form-control select_box input-lg">
                                                <option>10</option>
                                                <option>20</option>
                                                <option>30</option>
                                                <option>40</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">(Min 3 Characters Required)</label>
                                            <input type="search" className="form-control input-lg" placeholder='Search...' />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 text-end">
                                        <div class="btn-group ml-10">
                                            <button type="button" class="btn btn-primary btn-me">Status</button>
                                            <button type="button" class="btn btn-primary btn-me dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                                <span class="visually-hidden">Toggle Dropdown</span>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li><a class="dropdown-item" href="#">Active</a></li>
                                                <li><a class="dropdown-item" href="#">In Active</a></li>
                                                <li><a class="dropdown-item" href="#">Draft</a></li>
                                                <li><a class="dropdown-item" href="#">All</a></li>
                                            </ul>
                                        </div>
                                        <button className="btn btn-secondary btn-me ml-10"><FontAwesomeIcon icon={faUser} className="mr-10" />Import</button>
                                        <button className="btn btn-info btn-me ml-10"><FontAwesomeIcon icon={faUser} className="mr-10" />Export</button>
                                    </div>
                                </div>
                                <table className="table table-custom table-bordered-full table-bg mt-3">
                                    <tr>
                                        <th>S.N</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>
                                            <img class="img-40 rounded-circle p-0 mr-10" alt="Profile" src="./profile.jpg" />
                                            Rohan Patil
                                        </td>
                                        <td>PHP Developer</td>
                                        <td>
                                            <span class="badge bg-primary text-white">Active</span>
                                        </td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>
                                            <img class="img-40 rounded-circle p-0 mr-10" alt="Profile" src="./profile.jpg" />
                                            Ravi Shankar
                                        </td>
                                        <td>Senior PHP Developer</td>
                                        <td>
                                            <span class="badge bg-danger text-white">In Active</span>
                                        </td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>
                                            <img class="img-40 rounded-circle p-0 mr-10" alt="Profile" src="./profile.jpg" />
                                            Mukesh Kumar
                                        </td>
                                        <td>Magento Developer</td>
                                        <td>
                                            <span class="badge bg-primary text-white">Active</span>
                                        </td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        <li className="page-item"><a className="page-link" href="#">Previous</a></li>
                                        <li className="page-item"><a className="page-link" href="#">1</a></li>
                                        <li className="page-item"><a className="page-link" href="#">2</a></li>
                                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                                        <li className="page-item"><a className="page-link" href="#">Next</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">View Data</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-custom table-bordered">
                                    <tr>
                                        <th>Name</th>
                                        <td>Mukesh Kumar</td>
                                    </tr>
                                    <tr>
                                        <th>Email ID</th>
                                        <td>xyz@gmail.com</td>
                                    </tr>
                                    <tr>
                                        <th>Phone No.</th>
                                        <td>+91 000 000 0000</td>
                                    </tr>
                                    <tr>
                                        <th>Address</th>
                                        <td>Lorem ipsum is dummy text</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Table;